import { render, staticRenderFns } from "./joinDetail.vue?vue&type=template&id=9255cfe8&"
import script from "./joinDetail.vue?vue&type=script&lang=js&"
export * from "./joinDetail.vue?vue&type=script&lang=js&"
import style0 from "./joinDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports